<template>
  <div class="cashmere-page">
    <section class="cashmere-page__hero">
      <img
        class="cashmere-page__hero-image"
        :src="assets.heroTop"
        alt="Young·绒 2026 大赛主视觉"
      />
    </section>

    <div class="cashmere-page__body">
      <div class="cashmere-page__container">
        <section class="section-image-card">
          <img :src="assets.sectionOrganization" alt="组织机构" />
        </section>
        
        <img
            class="section-theme__title"
            :src="assets.titleTheme"
            alt="大赛背景及主题"
          />

        <section class="section-theme">
          
          <p class="section-theme__lead">
            “Young·绒—2026第二届中国创新创意设计大赛”将围绕“探索羊绒纤维的无限可能”为主题展开，旨在通过设计语言传递羊绒的臻质与实用，融合传统工艺与现代技术，兼顾艺术价值与市场需求，展现羊绒等纤维制品在全球市场的多元化潜力。大赛将重点关注设计作品中的环保理念、创新性、实用性和文化内涵，以推动纤维材料在时尚青春、家居生活、艺术创造等多领域的应用与发展，助力巩固羊绒产业领先地位。
          </p>

          <div class="section-theme__grid">
            <div class="video-panel">
              <div v-if="reviewVideoUrl" class="video-panel__player">
                <video
                  :src="reviewVideoUrl"
                  controls
                  preload="metadata"
                  playsinline
                  webkit-playsinline="true"
                >
                  您的浏览器暂不支持视频播放。
                </video>
              </div>
              <div v-else class="video-panel__placeholder">
                <div class="video-panel__icon">▶</div>
                <div class="video-panel__title">去年回顾视频</div>
                <div class="video-panel__desc">视频接口预留，后续对齐 OSS 地址</div>
              </div>
            </div>

            <div class="theme-copy">
              <p>
                随着全球时尚产业的迅速发展以及消费者对可持续、高品质生活方式的追求，羊绒作为一种天然、高端的纺织材料日益受到关注，其柔软舒适、保暖性强且环保的特性，使其成为设计师探索高端时尚和生活方式产品的一种理想选择。在这一背景下，鄂尔多斯市作为中国重要的羊绒生产基地，汇聚了丰富的资源与行业优势，立足东胜产业根基，以“Young·绒”为核心IP，特举办“Young·绒—2026第二届中国创新创意设计大赛”，大赛旨在通过挖掘羊绒材料的创意设计潜力，打造兼具国际视野与本土特色的创新设计平台，实现 “设计－转化－市场”全链条闭环，推动羊绒产业在设计、科技、环保等领域的创新发展，实现羊绒产业的品牌升级，提升中国羊绒设计及产业发展的国际影响力。
              </p>
            </div>
          </div>
        </section>

        <section class="section-image-card">
          <img :src="assets.sectionProcess" alt="大赛流程" />
        </section>

        <section class="section-image-card">
          <img :src="assets.sectionAwardsMain" alt="奖项设置" />
        </section>

        <section class="section-image-card section-image-card--soft">
          <img :src="assets.sectionAwardsExtra" alt="奖项说明" />
        </section>

        <section class="section-image-card">
          <img :src="assets.sectionTracks" alt="赛道方向" />
        </section>

        <section class="section-image-card">
          <img
            :src="assets.sectionJudgingSubmission"
            alt="评委与奖项评选及作品申报"
          />
        </section>

        <section class="section-image-card">
          <img :src="assets.sectionRights" alt="参赛要求及权益" />
        </section>

        <section class="section-image-card">
          <img :src="assets.sectionSupport" alt="实施保障" />
        </section>

        <section class="section-image-card section-image-card--compact">
          <img :src="assets.sectionOthers" alt="其他说明" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import heroTop from "@/assets/contest/cashmere-2026/hero-top.png";
import sectionOrganization from "@/assets/contest/cashmere-2026/section-organization.png";
import titleTheme from "@/assets/contest/cashmere-2026/title-theme.png";
import sectionProcess from "@/assets/contest/cashmere-2026/section-process.png";
import sectionAwardsMain from "@/assets/contest/cashmere-2026/section-awards-main.png";
import sectionAwardsExtra from "@/assets/contest/cashmere-2026/section-awards-extra.png";
import sectionTracks from "@/assets/contest/cashmere-2026/section-tracks.png";
import sectionJudgingSubmission from "@/assets/contest/cashmere-2026/section-judging-submission.png";
import sectionRights from "@/assets/contest/cashmere-2026/section-rights.png";
import sectionSupport from "@/assets/contest/cashmere-2026/section-support.png";
import sectionOthers from "@/assets/contest/cashmere-2026/section-others.png";

export default {
  name: "CashmereLongImage",
  data() {
    return {
      reviewVideoUrl:
        "https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/%E6%B0%B4%E6%9C%A8%E6%B8%85%E8%88%8D.mp4",
      assets: {
        heroTop,
        sectionOrganization,
        titleTheme,
        sectionProcess,
        sectionAwardsMain,
        sectionAwardsExtra,
        sectionTracks,
        sectionJudgingSubmission,
        sectionRights,
        sectionSupport,
        sectionOthers,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.cashmere-page {
  width: 100%;
  background: #f4f6fb;
  color: #1f2458;
}

.cashmere-page__container {
  width: min(1280px, calc(100vw - 48px));
  margin: 0 auto;
}

.cashmere-page__hero {
  overflow: hidden;
  background: #0967c8;
}

.cashmere-page__hero-image {
  display: block;
  width: 100%;
  height: auto;
}

.cashmere-page__body {
  padding: 54px 0 84px;
}

.section-image-card,
.section-theme {
  margin-bottom: 44px;
}

.section-image-card img,
.section-theme__title {
  display: block;
  width: 100%;
  height: auto;
}

.section-image-card img {
  border-radius: 22px;
}

.section-image-card--soft img {
  border-radius: 0;
}

.section-image-card--compact {
  margin-bottom: 0;
}

.section-theme {
  padding: 0;
}

.section-theme__title {
  display: block;
  width: min(520px, 100%);
  height: auto;
  margin: 0 auto 22px;
}

.section-theme__lead {
  width: auto;
  max-width: 1183px;
  min-height: 136px;
  margin: 0 auto 26px;
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 900;
  font-size: 20px;
  color: #61559A;
  line-height: 34px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.section-theme__grid {
  display: grid;
  grid-template-columns: minmax(0, 460px) minmax(0, 1fr);
  gap: 28px;
  align-items: stretch;
}

.video-panel,
.theme-copy {
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 18px 32px rgba(71, 86, 158, 0.08);
  
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 500;
  font-size: 20px;
  color: #61559A;
  line-height: 31px;
  text-align: justified;
  font-style: normal;
  text-transform: none;
}

.video-panel {
  overflow: hidden;
}

.video-panel__player iframe,
.video-panel__player video {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 320px;
  border: 0;
  background: #000;
}

.video-panel__placeholder {
  min-height: 320px;
  display: grid;
  place-items: center;
  gap: 10px;
  padding: 36px;
  text-align: center;
  background:
    linear-gradient(180deg, #edf1fb 0%, #e7ebf7 100%);
  color: #5a619a;
}

.video-panel__icon {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: rgba(52, 93, 194, 0.12);
  color: #3859c3;
  font-size: 24px;
}

.video-panel__title {
  font-size: 24px;
  font-weight: 700;
}

.video-panel__desc {
  font-size: 14px;
  line-height: 1.7;
}

.theme-copy {
  padding: 30px 32px;
  color: #4e578d;
  font-size: 15px;
  line-height: 2;
}

.theme-copy p {
  margin: 0;
}

.theme-copy p + p {
  margin-top: 16px;
}

@media (max-width: 1200px) {
  .section-theme__grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {
  .cashmere-page__container {
    width: min(100vw - 28px, 100%);
  }

  .section-theme {
    padding: 0;
  }
}
</style>
